var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"organization"}},[_c('TopList',{attrs:{"navList":_vm.navList},on:{"setType":_vm.setType}}),(_vm.type === 0)?_c('OrDetails',{attrs:{"orInfo":_vm.orInfo,"orgPeriodical":_vm.orgPeriodical},on:{"getDetails":_vm.getDetails}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }